// Configuration for the FPR Update Form frontend.
// REACT_APP_FPR_API_URL can be set in .env for production deployments.
const config = {
  apiUrl: process.env.REACT_APP_FPR_API_URL || 'http://localhost:8019',
};

export default config;
